var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1666 8.125C14.1666 7.77958 13.8866 7.5 13.5416 7.5H6.45825C6.11284 7.5 5.83325 7.77958 5.83325 8.125C5.83325 8.29833 5.90409 8.455 6.01825 8.56833L9.51075 12.2596C9.62534 12.4046 9.80034 12.5 9.99992 12.5C10.1995 12.5 10.3745 12.4046 10.4891 12.2596L13.982 8.56833C14.0958 8.455 14.1666 8.29833 14.1666 8.125Z",
    fill: "#758399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.a4b8a167a0703c9fbd637472128c8612.svg";
export { ForwardRef as ReactComponent };